<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Edycja pozycji' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical mb-2 w-100">

            <icc-complaint-position-edit
                [(complaint)]="data.complaint"
                [(complaintPosition)]="data.position"
                [(complaintPositionAttachments)]="data.attachments"
                [showRemoveButton]="false"
            ></icc-complaint-position-edit>

        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                iccButton
                (click)="save()"
                appearance="primary"
                [disabled]="data.position.invalidSerialNumber && data.position.complaintDocumentType === 'serialNumber'"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>